export default "__VITE_ASSET__BGlqhvwX__"